import React from 'react';

import { Button } from 'e100-react-components';
import { MapTypes } from './MapTypes';

import { useMenuState } from 'shared/hooks';
import { useStyles } from './styles';
import { useIsActiveGoogleMap } from 'entities/map';

export const MobileMapTypeSwitcher = () => {
  const classes = useStyles();
  const isActiveGoogleMap = useIsActiveGoogleMap();
  const { showMenu, handleShowMenu, handleCloseMenu } = useMenuState();

  return (
    <div className={classes.container}>
      <Button
        classes={{
          root: classes.button,
          label: classes.buttonLabel
        }}
        disableElevation={false}
        onClick={handleShowMenu}
      >
        <span className={isActiveGoogleMap ? classes.googleIcon : classes.hereIcon} />
      </Button>
      <MapTypes
        showMenu={showMenu}
        handleCloseMenu={handleCloseMenu}
      />
    </div>
  );
};
